export default __webpack_public_path__ + "static/media/close-btn-mobile.6fb92847.svg";